import React, { useEffect, useState } from 'react';

// MUI
import Slider, { SliderThumb } from '@mui/material/Slider';
import { WatchLater } from '@mui/icons-material';

interface ITimeSeriesSlider {
  ticks: number;
  value: number;
  checked: string | boolean | undefined;
  handleValueLabel: (x: number) => string;
  handleChangeCommited: (event: React.SyntheticEvent | Event, value: number | Array<number>) => void;
  valueLabelPlacement?: 'top' | 'bottom';
}

// Mirrors MUI's default (top-anchored) .MuiSlider-valueLabel positioning/arrow so the bubble
// opens downward instead - used for the compare companion row, which sits directly under
// another row and would otherwise have its value label cover it.
const bottomValueLabelSx = {
  '& .MuiSlider-valueLabel': {
    top: 'auto',
    bottom: '-10px',
    transformOrigin: 'top center',
    transform: 'translateY(100%) scale(0)',
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translateY(100%) scale(1)',
    },
    '&::before': {
      bottom: 'auto',
      top: 0,
      transform: 'translate(-50%, -50%) rotate(45deg)',
    },
  },
};

const IconThumb = (props: any) => {
  const { children, ...other } = props;

  return (
    
    <SliderThumb {...other}>
      <WatchLater
        sx={{
          fontSize: 16,
          color: 'white',
        }}
      />
      {children}
    </SliderThumb>
  );
};

const TimeSeriesSlider = (props: ITimeSeriesSlider) => {
  const { ticks, value, checked, handleValueLabel, handleChangeCommited, valueLabelPlacement = 'top' } = props;

  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (event: Event, newValue: number | number[]) => {
    if (typeof newValue === 'number') {
      setLocalValue(newValue);
    }
  };

  return (
    <Slider
      size="medium"
      aria-label="Timestamp"
      value={localValue}
      valueLabelDisplay="auto"
      valueLabelFormat={handleValueLabel}
      step={1}
      marks
      min={0}
      max={ticks}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommited}
      slots={{ thumb: IconThumb }}
      sx={{
        width: 100,
        mr: 3,
        ml: 1,
        ...(valueLabelPlacement === 'bottom' ? bottomValueLabelSx : {}),
      }}
      disabled={!checked}
    />
  );
};

export default TimeSeriesSlider;
